export default "__VITE_ASSET__j6YdtEOs__"